<template>
  <div>ec商品推荐</div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
</style>
